






















import { Vue, Component, Prop } from 'vue-property-decorator';
import { mdbCard, mdbCardBody, mdbCardTitle, mdbTooltip } from '@folky-tools/mdbvue';
import { BusinessFrontPage } from '@/models/businesses/business-front-page';
import { FrontPageImageType } from '@/models/common/front-page-image';

@Component({
    components: {
        mdbCard,
        mdbCardBody,
        mdbCardTitle
    }
})
export default class FrontPageImages extends Vue {
    @Prop(Boolean) private canWrite!: boolean;
    @Prop(BusinessFrontPage) private businessFrontPage!: BusinessFrontPage;
    @Prop(Boolean) private showImageUploadPrompt!: boolean;
    @Prop(Boolean) private pageContentLoaded!: boolean;

    private addNewFrontPageImage(): void {
        this.$emit('clicked-add-new-image');
    }

    private deleteFrontPageImage(type: FrontPageImageType): void {
        this.$emit('clicked-delete-image', type);
    }

    private changeFrontPageImage(type: FrontPageImageType): void {
        this.$emit('clicked-change-image', type);
    }
}
